import { byTenant } from "../../utils/byTenant";
import { OnboardingContainer as JameoOnboardingContainer } from "./OnboardingContainer.jameo";
import { AttractionOnboardingContainer } from "./OnboardingContainer.attraction";
import { OnboardingTemplate } from "./OnboardingTemplate";

export const OnboardingContainer = byTenant(
  JameoOnboardingContainer,
  AttractionOnboardingContainer
);
export { OnboardingTemplate };
